import React from 'react';

import { isNull } from '../is';

import { useResizeObserver } from './useResizeObserver';

export const useOffsetHeight = (containerRef: React.RefObject<HTMLElement>) => {
  const [height, setHeight] = React.useState(0);
  useResizeObserver(containerRef, () => {
    !isNull(containerRef.current) && setHeight(containerRef.current.offsetHeight);
  });

  return height;
};
